import { ChannelState, RootState } from '@/types/store'
import { GetterTree } from 'vuex'

export interface ChannelGetters extends GetterTree<ChannelState, RootState> {
  channels: (state: ChannelState) => ChannelState['channels']
}

export const getters: ChannelGetters = {
  channels(state): ChannelState['channels'] {
    return state.channels
  },
  isChannelLoading(state): ChannelState['isChannelLoading'] {
    return state.isChannelLoading
  },
}
